import type { DialogBusinessStatus } from '../../../types/aiRecruiter';
import {
  CANDIDATE_STATUS_BADGE_CLASS,
  CANDIDATE_STATUS_LABEL,
  type DialogCandidateStatusInput,
} from './candidateStatusFilter';

export interface DialogBadgeInput extends DialogCandidateStatusInput {
  dialogStatus?: DialogBusinessStatus | string | null;
}

export interface DialogBadge {
  label: string;
  className: string;
}

const DIALOG_STATUS_BADGE: Record<DialogBusinessStatus, DialogBadge> & Partial<Record<string, DialogBadge>> = {
  PROBLEM: {
    label: 'Проблема',
    className: 'bg-red-100 text-red-800 border border-red-300 font-semibold',
  },
  OVERDUE: {
    label: 'Просрочен',
    className: 'bg-yellow-100 text-yellow-800 border border-yellow-300',
  },
  WITH_REPLY: {
    label: 'С ответом',
    className: 'bg-gray-50 text-gray-900 border border-gray-200',
  },
  NO_REPLY: {
    label: 'Без ответа',
    className: 'bg-gray-50 text-gray-400 border border-gray-200',
  },
};

export const resolveDialogBadge = (dialog: DialogBadgeInput): DialogBadge | null => {
  if (dialog.dialogStatus) {
    // Защита от forward-compat: если бэк добавит новое значение DialogBusinessStatus
    // которого фронт ещё не знает — `DIALOG_STATUS_BADGE[unknownKey]` вернёт undefined.
    // Не падаем, а уходим в fallback (так не будет битых бейджей).
    const badge = DIALOG_STATUS_BADGE[dialog.dialogStatus];
    if (badge) {
      return badge;
    }
  }
  // Fallback для legacy диалогов без вычисленного dialogStatus или unknown-значения.
  const candidateStatus = dialog.candidateStatus ?? null;
  if (!candidateStatus) {
    return null;
  }
  return {
    label: CANDIDATE_STATUS_LABEL[candidateStatus],
    className: CANDIDATE_STATUS_BADGE_CLASS[candidateStatus],
  };
};
